export const sentNotificaionListTitle = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "Title", colWidth: "150px", key: "title" },
  { titleName: "Body", colWidth: "300px", key: "text" },
  { titleName: "Sent at", colWidth: "150px", key: "created_at" },
];
